export enum CustomErrorCode {
  NO_AVAILABLE_ADS = 'NO_AVAILABLE_ADS',
  GENERAL_ERROR = 'GENERAL_ERROR',
}
